<template>
  <router-link :to="'/' + link + '/' + model">
    <div class="text-center text-gray-400">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-12 h-8 -mt-1"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12.25 12h-.5m.5-4h-.5m.5 8h-.5"
        />
      </svg>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "id",
  data() {
    return {
      link: "edit/" + this.input.table,
      model: null
    };
  },
  props: ["input", "form", "rowdata"],
  created() {
    this.model = this.rowdata;
    if (this.input.options) {
      this.link = this.input.options;
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
